<div class="grid-cell">
  <button
    mat-icon-button
    (click)="previousClicked.emit()"
    [disabled]="!previousEnabled()"
    class="previous"
    [class.not-visible]="!visible()"
    >
    <mat-icon>arrow_back_ios_new</mat-icon>
  </button>
</div>

<div class="grid-cell center-content">
  <div class="length{{ visibleCount() }}" [class.not-visible]="!visible()">
    <cdk-virtual-scroll-viewport
      #scrollContainer
      orientation="horizontal"
      [itemSize]="thumbWidth"
      minBufferPx="1000"
      maxBufferPx="10000"
      class="scrolling-wrapper"
      (wheel)="onScrollWheel($event)"
      >
      <div
        class="thumb-labels-wrapper small"
        *cdkVirtualFor="let extSlide of slides(); let index = index"
        (click)="slideClicked.emit(extSlide)"
        >
        @if (isTextThumb(extSlide)) {
          <div class="thumb text">
            <div class="text-border">
              <div class="text-cropper" [innerHTML]="extSlide.caption | lineBreaks"></div>
            </div>
          </div>
        } @else {
          <img
            [src]="extSlide.previewpicture.thumb_n"
            [alt]="'Vorschau: ' + extSlide.caption"
            class="thumb"
            />
        }
        <div class="thumb-labels">
          <!-- Do not show "prev/next" labels on dynamic extension slides -->
          @if ((extSlide | isDynamicExtensionSlide) === false) {
            @let current = currentSlideIdx();
            @if (current && index === current - 1) {
              <h4>{{ 'next-slide-preview.thumbs.previous' | transloco }}</h4>
            }
            @if (index === current) {
              <h4>{{ 'next-slide-preview.thumbs.current' | transloco }}</h4>
            }
            @if (current && index === current + 1) {
              <h4>{{ 'next-slide-preview.thumbs.next' | transloco }}</h4>
            }
          }
          <h4 class="slide-counter">{{ index + 1 }}/{{ slides()!.length }}</h4>
        </div>
        @if (extSlide | isVideoSlide) {
          <mat-icon (click)="slideClicked.emit(extSlide)" class="video-icon small">play_arrow</mat-icon>
        }
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>

<div class="grid-cell">
  <button
    mat-icon-button
    (click)="nextClicked.emit()"
    [disabled]="!nextEnabled()"
    class="next"
    [class.not-visible]="!visible()"
    >
    <mat-icon class="ios-rotate180deg">arrow_back_ios_new</mat-icon>
  </button>
</div>
